import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { DlgWalrusModule } from 'dlg-walrus';
import { SharedFeaturesModule } from '@global/shared-features/shared-features.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    DlgWalrusModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports: [
    CommonModule,
    DlgWalrusModule,
    FormsModule,
    ReactiveFormsModule,
    SharedFeaturesModule
  ]
})
export class CoreUiModule { }
